import { RecaptchaProvider } from '@/presentation/contexts/recaptcha/recaptcha-provider'
import { ReactNode, lazy } from 'react'

const CbUnicoSuccessPage = lazy(() => import('@/presentation/pages/static/cb-unico-success-page'))

const FirstAccessPage = lazy(
  () => import('@/presentation/pages/static/first-access/first-access-page')
)

const FirstAccessCpfPage = lazy(
  () => import('@/presentation/pages/static/first-access/cpf/first-access-cpf-page')
)

export const makeCbUnicoSuccessPage = (): ReactNode => {
  return <CbUnicoSuccessPage />
}

export const makeFirstAccessPage = (): ReactNode => {
  return <FirstAccessPage />
}

export const makeFirstAccessCpfPage = (): ReactNode => {
  return (
    <RecaptchaProvider>
      <FirstAccessCpfPage />
    </RecaptchaProvider>
  )
}
